exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".rule-input[data-v-0a0024b8]  .el-input__inner{border:0}.el-input.is-disabled .el-input__inner[data-v-0a0024b8]{background-color:white;border:0}\n", ""]);

// exports
